import { AppShell, Text, Flex, Burger, Box } from '@mantine/core';

import { Breadcrumbs, useBreadcrumbs } from '@shared/lib';
import { useShowMe } from '@entities/auth';

type HeaderProps = {
  opened: boolean;
  toggle: () => void;
};

export const AdminHeader = ({ opened, toggle }: HeaderProps) => {
  const { data: me } = useShowMe();

  const context = useBreadcrumbs();
  const breadcrumb = context?.breadcrumb;

  return (
    <AppShell.Header
      ml={{ base: '1.5rem', sm: '2.5rem' }}
      py={{ base: 16 }}
      px={{ base: 16, md: 32 }}
    >
      <Burger opened={opened} onClick={toggle} hiddenFrom='sm' size='sm' />

      <Flex
        w='100%'
        miw={0}
        gap={16}
        justify={{
          base: 'flex-end',
          md: breadcrumb ? 'space-between' : 'flex-end',
        }}
        wrap='nowrap'
      >
        {breadcrumb && (
          <Box
            component='nav'
            aria-label='Хлебные крошки'
            display={{ base: 'none', md: 'block' }}
            style={{
              flexBasis: 0,
              flexGrow: 1,
              flexShrink: 1,
              minWidth: 0,
              overflow: 'hidden',
            }}
          >
            <Breadcrumbs />
          </Box>
        )}

        <Flex gap={16} px={16} align='center' flex='0 0 auto'>
          <Flex gap={2} direction='column'>
            <Text fw={600} c='primary.4'>
              {`${me?.profile.firstName}, ${me?.profile.lastName}`}
            </Text>
            <Text fz={12} c='tertiary.4'>
              {me?.role.name}
            </Text>
          </Flex>
        </Flex>
      </Flex>
    </AppShell.Header>
  );
};
